'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentUnzerAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 85 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 1.30005,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 5.3,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M37.8202 27.0571V37.6912H33.4874V28.7985C33.4874 26.6072 31.877 25.4246 30.3623 25.4246C29.05 25.4246 28.0246 26.0597 27.0398 27.4848V37.692H22.707V29.8439C22.2696 29.9971 21.8201 30.126 21.3782 30.2259C21.1463 34.7519 17.9873 37.9786 13.6959 37.9786C9.23661 37.9786 6 34.4942 6 29.6937V21.3675H10.3335V29.6937C10.3335 31.4908 11.2144 33.5899 13.6966 33.5899C15.9801 33.5899 16.9084 31.8133 17.0417 30.129C15.2415 29.362 14.1273 27.5138 14.1273 25.0594C14.1273 22.5173 15.9989 21.0221 17.8043 21.0221C20.1141 21.0221 21.3925 23.3522 21.3805 25.6678C21.3805 25.6678 22.0212 25.4353 22.707 25.0411V21.3667H27.0398V22.7674C28.5222 21.5459 29.891 21 31.4705 21C33.2156 21 34.8245 21.6184 35.9998 22.7415C37.1743 23.8638 37.8202 25.3964 37.8202 27.0571ZM39.5481 25.2363H46.8841L39.1543 34.5384L39.1483 34.5453V37.6912H52.8837V33.8285H45.1103L52.8777 24.4021L52.8837 24.3953V21.3675H39.5481V25.2363ZM66.9226 23.2836C68.3756 24.7765 69.1436 26.8946 69.1436 29.4093V30.9235H57.5026C57.803 32.9372 59.2327 34.1381 61.3317 34.1381C63.0761 34.1381 64.5849 33.4275 65.2685 32.2845L65.2798 32.2647L65.3001 32.2739L68.6971 33.8232L68.6851 33.8476C67.3276 36.4865 64.6256 38 61.27 38C56.4516 38 53.2142 34.5971 53.2142 29.532C53.2142 27.144 54.0733 24.9664 55.6332 23.3995C57.1322 21.8936 59.1341 21.064 61.2708 21.064C63.5557 21.0648 65.5094 21.8319 66.9226 23.2836ZM64.9244 27.4932C64.5683 25.8081 63.2049 24.804 61.2708 24.804C59.506 24.804 58.1493 25.8081 57.6359 27.4932H64.9244ZM80 21.2478C79.4256 21.0648 78.7721 21.0648 78.7721 21.0648C77.3506 21.0648 75.9797 21.6206 74.8044 22.6721V21.3675H70.4716V37.692H74.8044V27.5671C75.6589 25.9248 76.9704 25.0205 78.4973 25.0205C78.4973 25.0205 79.1839 25.0266 79.6115 25.1539L80 21.2478Z",
          fill: "#FC1154"
        }
      )
    ]
  }
);
const VpPaymentUnzerAsset = forwardRef(PaymentUnzerAsset);

export { VpPaymentUnzerAsset as default };
